import React, { useEffect, useRef } from "react";
import { useSpring, animated, config } from "react-spring";
import styled from "@emotion/styled";

const AccordionDetails = ({ section, expanded, detailsTextColor, detailsBackgroundColor }) => {
  const maxHeight = 275;
  const ref = useRef(null);

  const ScrollSection = styled.div`
    scrollbar-width: thin;
    scrollbar-color: #999 #fafafa;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      width: 0.5vw;
      background-color: #fafafa;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #999;
      border-radius: 9999px;
    }
  `;

  const [style, animate] = useSpring(() => ({ height: expanded === section.id ? maxHeight + "px" : "0px" }), []);

  useEffect(() => {
    animate({
      height:
        (expanded === section.id ? (ref.current.clientHeight > maxHeight ? maxHeight : ref.current.clientHeight) : 0) + "px",
      config: config.default,
    });
  }, [expanded]);
  return (
    <animated.div
      style={{
        ...style,
        maxHeight: maxHeight,
        height: style.height,
      }}
    >
      <ScrollSection>
        <div
          ref={ref}
          style={{
            backgroundColor: detailsBackgroundColor,
            color: detailsTextColor,
          }}
        >
          {section.summary === "features" && section.featuresText !== `""` ? (
            <div
              style={{
                lineHeight: "1.15vw",
                padding: "0.25vw 1vw",
              }}
            >
              <p
                style={{
                  fontSize: "0.85vw",
                }}
              >
                {section.featuresText}
              </p>
            </div>
          ) : null}

          {section.summary === "benefits" && section.benefitsText !== `""` ? (
            <div
              style={{
                lineHeight: "1.15vw",
                padding: "0.25vw 1vw",
              }}
            >
              <p
                style={{
                  fontSize: "0.85vw",
                }}
              >
                {section.benefitsText}
              </p>
            </div>
          ) : null}

          {section.summary === "downloads" && section.pdfData !== undefined ? (
            <div
              style={{
                lineHeight: "1.15vw",
                padding: "0.25vw 1vw",
              }}
            >
              {section.pdfData.map((pdf) => {
                return (
                  <div
                    style={{
                      padding: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    key={pdf.id}
                    onClick={pdf.eventTracker}
                  >
                    <a
                      href={pdf.path}
                      target="_blank"
                      style={{
                        textDecoration: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "26rem",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: detailsTextColor,
                        fontSize: "0.85vw",
                      }}
                    >
                      <svg
                        style={{ marginRight: "0.85vw" }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="0.85vw"
                        viewBox="0 0 14.727 18.409"
                      >
                        <path
                          id="file-pdf"
                          d="M12.284,8.443h5.063L12.284,3.381V8.443M5.841,2H13.2l5.523,5.523V18.568a1.841,1.841,0,0,1-1.841,1.841H5.841A1.841,1.841,0,0,1,4,18.568V3.841A1.841,1.841,0,0,1,5.841,2m3.774,8.652a13.7,13.7,0,0,1-1.933,4.317S4.46,16.645,5.224,17.9c.617.994,2.135-.037,3.443-2.467a16.76,16.76,0,0,1,3.9-.755s3.553,1.592,4.041-.1c.479-1.712-2.817-1.325-3.406-1.151a6.22,6.22,0,0,1-2.3-2.955s1.049-3.636-.561-3.59-1,2.881-.727,3.774m.746.957a6.936,6.936,0,0,0,1.74,2.264,23.2,23.2,0,0,0-3.12.828A17.65,17.65,0,0,0,10.36,11.61m3.617,2.5c.534-.147,2.145.138,2.08.442s-2.08-.442-2.08-.442M7.47,15.807a3.41,3.41,0,0,1-1.537,1.841c-.212,0,.644-1.473,1.537-1.841m2.89-6.379c0-.064-.331-2.025,0-1.979C10.857,7.523,10.36,9.364,10.36,9.428Z"
                          transform="translate(-4 -2)"
                          fill="rgb(62, 186, 124)"
                        />
                      </svg>

                      {pdf.title}
                    </a>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <a
                        href={pdf.path}
                        target="_blank"
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="0.85vw" viewBox="0 0 15.161 18.409">
                          <path
                            id="download_1_"
                            section-name="download(1)"
                            d="M5,21.409H20.161V19.243H5M20.161,9.5H15.829V3h-6.5V9.5H5l7.58,7.58Z"
                            transform="translate(-5 -3)"
                            fill="rgb(62, 186, 124)"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      </ScrollSection>
    </animated.div>
  );
};
export default AccordionDetails;
